import { useRecoilState } from "recoil";

import { reportsChartDrawerAtom } from "@ryde/shared";

export const useReportChartDrawer = () => {
  const [isChartDrawerOpen, setChartDrawerOpen] = useRecoilState(
    reportsChartDrawerAtom,
  );

  const openReportChartDrawer = (): void => {
    setChartDrawerOpen(true);
  };

  const closeReportChartDrawer = (): void => {
    setChartDrawerOpen(false);
  };

  return {
    isChartDrawerOpen,
    openReportChartDrawer,
    closeReportChartDrawer,
  };
};
